"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_game__console(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "d9f3d27c-5b19-4203-96d1-b45c142587d5",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "game-console-mid"), /*#__PURE__*/React.createElement("g", {
    id: "3fc183b5-166f-47b6-9285-74dd022bd923",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "3f421a2a-e286-4a93-a524-463e350a39f8",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,125.08H60.76a6.16,6.16,0,0,0-5.77,4L51.69,138a18.24,18.24,0,0,1-17.08,12h0a16.75,16.75,0,0,1-16.44-19.21l9.61-67.42A24.73,24.73,0,0,1,52.16,42h87.68a24.73,24.73,0,0,1,24.38,21.37l9.61,67.42A16.75,16.75,0,0,1,157.39,150h0a18.24,18.24,0,0,1-17.08-12l-3.3-8.91a6.16,6.16,0,0,0-5.77-4Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 70,
    x2: 62,
    y2: 102,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 86,
    x2: 78,
    y2: 86,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124,96h0m0-4a4,4,0,1,0,4,4A4,4,0,0,0,124,92Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,72h0m0-4a4,4,0,1,0,4,4A4,4,0,0,0,124,68Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,84h0m0-4a4,4,0,1,0,4,4A4,4,0,0,0,136,80Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,84h0m0-4a4,4,0,1,0,4,4A4,4,0,0,0,112,80Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }));
}

var _default = ic_game__console;
exports.default = _default;